import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback/_layout"
)({
    component: () => <FromLayout />,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.tracking.from.title"),
    }),
});

function FromLayout() {
    return <Outlet />;
}
